import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { MainState } from './types';
import { RootState } from '../types';

export const state: MainState = {
    filterLocations: '',
    filterLocationIds: [],
    standByFilterLocations: '',
    filterScenarios: '',
    standByFilterScenarios: '',
    scenarioLocationsVisible: false,
    searchResults: [],
    mapBounds: null,
    mapFlyTo: null,
    locationPhoto: null,
    models: [],
    model: null,
    subModels: [],
    subModel: null,
    areaSetVisible: 0,
    poiSetsVisible: [],
    heatMapSetsVisible: [],
    scenarios: [],
    foundScenarioIds: null,
    scenarioLocations: [],
    scenario: null,
    drivers: [],
    scenarioDifferences: null,
    locations: [],
    locationsNotExcluded: [],
    onlinePois: [],
    propertiesChart: null,
    matchingLocations: [],
    matchingScores: [],
    locationDrivers: null,
    location: null,
    locationProperties: null,
    locationPropertiesOld: null,
    locationScores: null,
    locationIsoLines: null,
    locationCatchmentArea: null,

    area: null,
    modelParameters: null,
    scenarioProcessingLog: null,
    normalizedScoresFunctions: null,
    locationEditing: null,
    locationClosing: null,
    scenarioEditing: null,
    scenarioNameEditing: null,
    scenarioMerging: null,
    bulkUploadLocations: null,
    fetchCatchmentAreaBusy: null,
    pois: [],
    heatMapPoints: [],
    readOnly: false,
    isoLinesFetchingBusy: null,
    log: null,
    isoLineParameters: null,
    matchingColors: ["#0095d5", "#f17f29", "#4caf50", "#7e3ff2", "#cddc39", "#e91e63"],
    isoLineSet: null,
    isoLineMinutes: 0,
    catchmentArea: null,
    satelliteView: false,
    areas: [],
    mapState: { zoom: 8, center: { lng: 4.914908662529424, lat: 52.34830298821911 }, bearing: 0, pitch: 0 },
    poisInRange: [],
    poisInRangeSetStates: {},
    agentMessage: null,
    agentMessages: [],
    nCalcTester: false,
    modelSort: '',
};

const namespaced = true;

export const main: Module<MainState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
